import React, { useEffect, useMemo, useState } from 'react'
// import { GigStepProperty, GigStepPropertyWithValue, Milestone, MilestoeStep, MilestonSpecifications } from '../../../types/collaborations/CollaborationTypes';

import Choice from './form/Choice';
import { useParams } from 'react-router-dom';
// import { submitMilestoneStep } from '../../../services/api/collaboration';
import FileInput from './form/FileInput';
import WYSIWYG from './form/WYSIWYG';
import { GigStepProperty, GigStepPropertyWithValue, Milestone, MilestoneStep, MilestonSpecifications } from 'types/campaign/collaborations';
import inModal from 'utils/hoc/inModal';
import { processCollaborationMilestoneStep } from 'services/api/campaign/collaboration';
import { store } from 'store';
import { usePrivileges } from 'hooks/useAuth';
import { PRIVILEGE } from 'constants/privilege';
import FormFields from './form/FormFields';
import { toast } from 'react-toastify';

interface FormBuilderProps {
    title: string,
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    activeMilestone: Milestone,
    step: MilestoneStep
}



const FormBuilder: React.FC<FormBuilderProps> = ({ activeMilestone, step, onClose }) => {

    const privileges = usePrivileges();

    const [properties, setProperties] = useState<GigStepPropertyWithValue[]>([]);

    const { campaignId, collaborationId, milestoneId } = useParams();

    const [submitting, setSubmitting] = useState(false);

    const isValid = () => {
        for (let property of properties) {
            if(['approval'].includes(property.key)) continue;
            if (property.mandatory && !property.value) return false;
        }

        return true;
    }

    const validateForm = () => {
        let hasErrors = false
        let updated_properties = [...properties]
        for (let i in updated_properties) {
            if (updated_properties[i].mandatory && !updated_properties[i].value) {
                updated_properties[i] = { ...updated_properties[i], error: `${updated_properties[i].label} is required.` }
                hasErrors = true;
            }
        }

        if(hasErrors){
            setProperties(updated_properties);
        }

        return hasErrors;
    }

    const onSubmit = async () => {
        const isValid = !(validateForm());
        const agencyId = store.getState().auth.selectedAgencyId;
        if (!isValid || !campaignId || !collaborationId || !milestoneId || !agencyId) return;

        let data: any = {};

        for (let property of properties) {
            if(property.type === 'choice' && typeof property.value !== 'string' && typeof property.value === 'object'){
                for(let [key, value] of Object.entries(property.value)){
                    data[`${property.key}[${key}]`] = value;
                }
            }else{
                data[property.key] = property.value;
            }
        }

        try {
            setSubmitting(true);
            await processCollaborationMilestoneStep(agencyId, campaignId, collaborationId, milestoneId, {step: step.gig_step.slug, ...data});
            onClose(true);
        } catch (error:any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? "Unknown error occurred.")
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className='form-builder-form'>
            <FormFields step={step} activeMilestone={activeMilestone} onChange={(updatedProperties) => setProperties(updatedProperties)} />
            <div className="milestone-step-actions">
                <button className="theme-btn theme-btn-primary-outlined" onClick={() => onClose()}>Cancel</button>
                <button className="theme-btn theme-btn-primary" disabled={!isValid() || submitting || !privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.PROCESS)} onClick={onSubmit}>Submit</button>
            </div>
        </div>
    )
}

const FormBuilderModal: React.FC<FormBuilderProps> = (props) => {
    const { title } = props;

    const ModalComponent = useMemo(() => inModal(FormBuilder, title), [title])

    return <ModalComponent {...props} />
}

export default FormBuilderModal;